import * as React from 'react'

export const SVG_Magnifier = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="8 8 32 32">
        <g fill="currentColor" fillRule="evenodd" transform="scale(1.5)">
            <path d="M21.055 20.583l4.674 4.716a.8.8 0 0 1 0 1.114.757.757 0 0 1-.55.236.778.778 0 0 1-.551-.236l-4.74-4.769a8.643 8.643 0 0 1-5.201 1.73C9.89 23.373 6 19.468 6 14.686S9.891 6 14.687 6c4.795 0 8.686 3.905 8.686 8.687 0 2.28-.89 4.35-2.318 5.896zM7.572 14.687c0 3.918 3.184 7.114 7.115 7.114a7.112 7.112 0 0 0 7.114-7.114c0-3.93-3.197-7.115-7.114-7.115-3.93 0-7.115 3.197-7.115 7.115z" />
        </g>
    </svg>
)
